.tagCategory,
.tagCategoryActive {
    display: flex;
    margin: 0px;
    align-items: center;
}

.tagCategoryActive {
    border-color: var(--hps-dark-blue);
    border: 1px solid var(--hps-dark-blue);
    border-radius: 9px;
}

.tagContainer {
    display: flex;
    flex: 1 1;
    margin-bottom: 20px;
}

.allTagCategories,
.allTagsContainer {
    width: 45%;
}
.allTagCategories {
    margin-right: auto;
}

.link {
    display: flex;
    align-items: center;
    margin-right: auto;
}

.tag {
    display: flex;
}

.buttonContainer {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 10px;
}